'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils_baseUrls_core = require('./core.js');
var utils_baseUrls_risk = require('./risk.js');

var urls = {
  core: utils_baseUrls_core["default"],
  risk: utils_baseUrls_risk["default"]
};

exports["default"] = urls;
